import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';

@Component({
  selector: 'app-h2',
  template: '<h2 class="{{ngClass}}"><ng-content></ng-content></h2>',
  styleUrls: ['./h2.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class H2Component extends BaseTypographyComponent {
}
